import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
function ThirdPartyRoutes() {
  const { token, user } = useSelector(state => state.auth);

  const redirectTo = role_id => {
    switch (parseInt(role_id)) {
      case 3:
      case 5:
      case 6:
      case 1:
        return '/zatca/thirdparty';
      default:
        return '/login';
    }
  };

  const getRedirectPath = () => {
    if (!token) return '/login';
    return redirectTo(user?.role_id);
  };
  return user?.role_id == 3 || user?.role_id == 5 || user?.role_id == 1|| user?.role_id == 6 ? (
    <Outlet />
  ) : (
    <Navigate to={getRedirectPath()} />
  );
}

export default ThirdPartyRoutes;
